export const LOADER_DISPLAYED = 'LOADER_DISPLAYED';

export const loaderDisplayed = payload => dispatch =>
  dispatch({
    type: LOADER_DISPLAYED,
    payload,
  });
